module.exports = __webpack_public_path__ + "static/media/Icons-nav-numbers.16b7c340.svg";